import {
    ADD_CITY_FAILED,
    ADD_CITY_LOADING,
    ADD_CITY_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};


export const addNewCityReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_CITY_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_CITY_SUCCESS:
            return {
                ...state,
                loading: false,
                mesg: action.payload.message,
                status: action.payload.code,
                error: null,
            };
        case ADD_CITY_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




